import { render, staticRenderFns } from "./CampaignsCalendar.vue?vue&type=template&id=3a241147&scoped=true&"
import script from "./CampaignsCalendar.vue?vue&type=script&lang=js&"
export * from "./CampaignsCalendar.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsCalendar.vue?vue&type=style&index=0&id=3a241147&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a241147",
  null
  
)

export default component.exports